"use client";

import { Header } from "@/components/shared/public";
import { useTranslations } from "next-intl";

const Head = () => {
  const t = useTranslations("sized");

  return <Header title={t("head.title")} />;
};

export default Head;
